import { Label } from 'components/Label';
import { GamePuzzleState } from 'data/generated';
import styled from 'styled-components';
import { Colors } from 'styles/colors';

function getGamePuzzleStateTagColors(state: GamePuzzleState): {
    tagColor: string;
    tagTextColor?: string;
} {
    switch (state) {
        case GamePuzzleState.Locked:
            return { tagColor: Colors.secondary.red };
        case GamePuzzleState.Unlocked:
            return { tagColor: Colors.secondary.blue };
        case GamePuzzleState.Completed:
            return { tagColor: Colors.secondary.green };
        case GamePuzzleState.Archived:
            return { tagColor: Colors.secondary.mediumGrey };
    }
}

export const GamePuzzleStateTag = ({ state, label }: { state: GamePuzzleState; label?: string }) => {
    const { tagColor, tagTextColor = Colors.primary.white } = getGamePuzzleStateTagColors(state);
    return (
        <Container>
            {label && <Label>{label}</Label>}
            <Tag tagColor={tagColor} tagTextColor={tagTextColor}>
                {state}
            </Tag>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

const Tag = styled.div<{ tagColor: string; tagTextColor: string }>`
    font-size: 14px;
    color: ${({ tagTextColor }) => tagTextColor};
    background-color: ${({ tagColor }) => tagColor};
    width: min-content;
    padding: 5px 10px;
    border-radius: 10px;
`;
